import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgSofaV2Fill = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M1.08 18.765a.54.54 0 0 1 .54-.54h1.946a.54.54 0 1 1 0 1.08H1.62a.54.54 0 0 1-.54-.54M16.856 18.765a.54.54 0 0 1 .54-.54h1.945a.54.54 0 1 1 0 1.08h-1.945a.54.54 0 0 1-.54-.54" />
      <path
        fillRule="evenodd"
        d="M0 8.507a2.053 2.053 0 1 1 4.106 0v2.06c0 .474.384.857.857.857H16a.857.857 0 0 0 .857-.857v-2.06a2.053 2.053 0 1 1 4.106 0v5.943c0 1.074-.87 1.945-1.945 1.945H1.945A1.945 1.945 0 0 1 0 14.45z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M4.43 0a2.377 2.377 0 0 0-2.377 2.377v2.997a3.133 3.133 0 0 1 3.133 3.134v1.087c0 .414.336.75.75.75h9.09a.75.75 0 0 0 .75-.75V8.508a3.133 3.133 0 0 1 3.35-3.126V2.377A2.377 2.377 0 0 0 16.747 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSofaV2Fill;
